exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-area-stage .control-label{padding-top:10px}.form-area-stage .checkbox-group{margin-top:10px}.form-area-stage.theme-primary .col-sm-10 .date-time-stage{width:47.2%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/components/base/form-area/form-area.scss
// module id = 569
// module chunks = 2